// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

export class Diagnostic {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):Diagnostic {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsDiagnostic(bb:flatbuffers.ByteBuffer, obj?:Diagnostic):Diagnostic {
  return (obj || new Diagnostic()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsDiagnostic(bb:flatbuffers.ByteBuffer, obj?:Diagnostic):Diagnostic {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Diagnostic()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

code():string|null
code(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
code(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

severity():string|null
severity(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
severity(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

message():string|null
message(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
message(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

nodeId():string|null
nodeId(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
nodeId(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

value():string|null
value(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
value(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startDiagnostic(builder:flatbuffers.Builder) {
  builder.startObject(5);
}

static addCode(builder:flatbuffers.Builder, codeOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, codeOffset, 0);
}

static addSeverity(builder:flatbuffers.Builder, severityOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, severityOffset, 0);
}

static addMessage(builder:flatbuffers.Builder, messageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, messageOffset, 0);
}

static addNodeId(builder:flatbuffers.Builder, nodeIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, nodeIdOffset, 0);
}

static addValue(builder:flatbuffers.Builder, valueOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, valueOffset, 0);
}

static endDiagnostic(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createDiagnostic(builder:flatbuffers.Builder, codeOffset:flatbuffers.Offset, severityOffset:flatbuffers.Offset, messageOffset:flatbuffers.Offset, nodeIdOffset:flatbuffers.Offset, valueOffset:flatbuffers.Offset):flatbuffers.Offset {
  Diagnostic.startDiagnostic(builder);
  Diagnostic.addCode(builder, codeOffset);
  Diagnostic.addSeverity(builder, severityOffset);
  Diagnostic.addMessage(builder, messageOffset);
  Diagnostic.addNodeId(builder, nodeIdOffset);
  Diagnostic.addValue(builder, valueOffset);
  return Diagnostic.endDiagnostic(builder);
}
}
